import { useCallback, useMemo } from 'react';
import { availabilityRelationsSelector } from 'slices/availabilityRelation.slice';
import {
  selectObjectTypesMap,
  selectObjectTypesTree,
} from 'slices/objectTypes.slice';
import { useAppSelector } from 'slices/store';
import {
  getAvailabilityRelatedTypes,
  getAvailabilityRelationChange,
} from 'utils/associations';
import type { TTEObject, TType } from '@timeedit/types';
import type { FormInstance } from '@timeedit/ui-components/antd';
import BulkEditAssociation from './BulkEditAssociation';
import type { BulkEditAction } from './common';

type Props = {
  action: BulkEditAction;
  form: FormInstance;
  type: TType;
};

const BulkEditAvailabilityRelations = ({ action, form, type }: Props) => {
  const allAvailabilityRelations = useAppSelector(
    availabilityRelationsSelector
  );
  const typeMap = useAppSelector(selectObjectTypesMap);
  const typeTree = useAppSelector(selectObjectTypesTree);

  const objectTypes = useMemo(
    () =>
      getAvailabilityRelatedTypes(
        [type?.id],
        typeTree,
        allAvailabilityRelations,
        typeMap
      ),
    [type, typeTree, allAvailabilityRelations, typeMap]
  );

  const onSelectedObjectsChange = useCallback(
    (addedObjects: TTEObject[], fieldKey: string) => {
      getAvailabilityRelationChange(
        addedObjects,
        [],
        allAvailabilityRelations,
        typeTree,
        [type?.id],
        ({ availabilityRelations }) => {
          form.setFieldValue(
            fieldKey,
            availabilityRelations.map((ar) => ({
              availabilityTypeId: ar.availabilityTypeId,
              objectId: ar.objectIds[0],
            }))
          );
        }
      );
    },
    [allAvailabilityRelations, typeTree, type, form]
  );

  return (
    <BulkEditAssociation
      action={action}
      form={form}
      objectTypes={objectTypes}
      relationType="availabilityRelations"
      onChangeOverride={onSelectedObjectsChange}
    />
  );
};

export default BulkEditAvailabilityRelations;
